/**
 *  AudioParams
 *
 *  Created by Legman on 25/02/2016.
 *
 */

/**
 * @constructor
 */
function AudioParams() {
    /**
     * @type {number}
     */
    this.volume = 1.0;

    /**
     * @type {boolean}
     */
    this.loop = false;

    /**
     * @type {number}
     */
    this.delay = 0.0;

    /**
     * @type {number}
     */
    this.fadeIn = 0.0;

    /**
     * @type {number}
     */
    this.priority = 0;

    /**
     * @type {function}
     */
    this.callback = null;

    /**
     * @type {*}
     */
    this.scope = window;
}
module.exports = AudioParams;
